function PromiseAllLimit<T>(promiseFns: (() => Promise<T>)[], limit: number) {
  return new Promise((resolve, reject) => {
    let index = 0;
    let activePromises = 0;
    let results: T[] = [];
    let resolvedCount = 0;

    function next() {
      if (resolvedCount === promiseFns.length) {
        resolve(results);
        return;
      }

      while (activePromises < limit && index < promiseFns.length) {
        const currentIndex = index;
        const currentPromiseFn = promiseFns[currentIndex];
        index++;
        activePromises++;

        currentPromiseFn()
          .then(result => {
            results[currentIndex] = result;
            resolvedCount++;
            activePromises--;
            next();
          })
          .catch(error => {
            reject(error);
          });
      }
    }

    next();
  });
}

export default PromiseAllLimit;

// // 示例使用
// const createPromiseFn = (id, delay) => () => new Promise(resolve => setTimeout(() => resolve(id), delay));

// const promiseFns = [
//   createPromiseFn(1, 1000),
//   createPromiseFn(2, 2000),
//   createPromiseFn(3, 3000),
//   createPromiseFn(4, 4000),
//   createPromiseFn(5, 5000)
// ];

// PromiseAllLimit(promiseFns, 3).then(results => {
//   console.log(results);
// }).catch(error => {
//   console.error(error);
// });
